import { PlotType, StudyManager, newConfiguration } from '@/common/plotDefinitions.js';
import { getReportFiles } from '@/common/commonFunctions.js';
import { Individual_Type, Comparison_Type } from '@/common/sharedDefinitions/reportDefinitions.js';
import { ExtraConfigKey, FilesConfigKey, ConfigName, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import GeneratePlot from '@/functions/generatePlot.js';
import { getDataFiles2D } from '@/functions/extractData.js';
import { DATA_TYPE_EXTERN_PAYLOAD, DATA_TYPE_DATA } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js';
import defaultOrderGraphs from '@/common/defaultOrderGraphs';
import store from '@/store';
import axios from 'axios';

const reNumber=RegExp('\\d+')

const SelectAll_State = 'ALL';

const nonApplicableKeysTemplate = ['projectId', 'shortId', 'id'];
const elementsValidate = [
  { key: 'dateTest', text: 'Test Date' },
  { key: 'operator', text: 'Operator' },
  { key: 'hypothesis', text: 'Hypothesis' },
  { key: 'protocol', text: 'Protocol' },
  { key: 'equipment', text: 'Equipment' },
];

const EXTERN_STUDY = 'EXTERN';

const ReportInfo = {
  constants: {
    //Constants of the reports
    SelectAll_State: SelectAll_State,
  },
  getConfigFromBackendPayload(parent, report){
    // Checks if it requires mapping from payload of the backend
    if(typeof(report.backendRequest) !== 'undefined'){
      for(const [sectionconfig, backendPayload] of Object.entries(report.backendRequest)){
        report[ExtraConfigKey][sectionconfig] = {}
        report.configuration[sectionconfig] = {}
        newConfiguration.mapConfigFromBackendPayload(parent, backendPayload, report.configuration[sectionconfig], report[ExtraConfigKey], sectionconfig)
      }
      delete report.backendRequest
      if(report.forceUpdateWhenOpen){
        const errTitle = 'Force Update not executed';
        const errText = 'Forcing update from the back-end when opening it is not supported when parsing the configuration from a backend payload. please contact the administrator of the system'
        const errZone = 'Configuration from backend payload';
        parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone);
        report.forceUpdateWhenOpen = false
      }
    }
  },
  async getPlotsFromBackEnd(parent, report, typeCard, url_req = GeneratePlot.URLPlots, extraPayload = {}) {
    const baseStudy = StudyManager.getStudyBase(typeCard);
    if (typeof baseStudy === 'undefined') {
      const warnTitle = 'Warning study not identified';
      const warnText = `Study '${typeCard}' not identified. Element skipped`;
      const warnZone = 'Report Cards Assembly';
      parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone);
      return;
    }
    const plotTypeInfo = PlotType[baseStudy];
    const study = report.configuration[typeCard];
    const scanActivated = (ConfigName.BasePropStudy in study
                          && ConfigName.MappingDiscrete in study[ConfigName.BaseAxisProperties]
                          && study[ConfigName.BaseAxisProperties][ConfigName.MappingDiscrete]
                          && ConfigName.MappingScanDiscrete in study[ConfigName.BaseAxisProperties]);

    const xType = plotTypeInfo.xAxisType;
    const yType = plotTypeInfo.yAxisType;
    let statesData = (parent.isVisibleStateReportViewer
                      ? report.configuration[typeCard][ConfigName.BasePropStudy][ConfigName.StateTypeStudy]
                      : store.getters.getReportStatesListReportViewer); //By default it gets all the values
    if(!Array.isArray(statesData)){
      statesData = [statesData]
    }
    const reverseCurrent = (typeof report.configuration[typeCard][ConfigName.BasePropStudy][ConfigName.CurrentDirectionReverse] !== 'undefined'
                            ? report.configuration[typeCard][ConfigName.BasePropStudy][ConfigName.CurrentDirectionReverse]
                            : 'Forward_Current');
    const scan = (scanActivated
                  ? parseInt(study[ConfigName.BaseAxisProperties][ConfigName.MappingScanDiscrete])
                  : '');

    const dataFiles = await getDataFiles2D(parent,
                                                       report,
                                                       xType,
                                                       yType,
                                                       [...statesData],
                                                       reverseCurrent,
                                                       scan); //Get the files with data the report
    if (dataFiles.length === 0) {
      const infoTitle = 'Data Analysis';
      const infoText = 'The report needs at least one file type Data to create the report';
      const infoZone = 'Report Cards Assembly';
      parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.INFO, infoTitle, infoText, infoZone);
      return;
    }

     if (typeCard == 'ID') { // Special case for impedance. Consists of multiple requests
       if ((typeof report.configuration[typeCard].CurveFit !== 'undefined') && 'equivalentCircuit' in report.configuration[typeCard].CurveFit) { // Check if Equivalent Citruit Fit is requested
         parent.loadingKey += dataFiles.length; //Trick to update the Loading effect
          parent.totalSteps += dataFiles.length; //Trick to update the Loading effect
          for (let i = 0; i < dataFiles.length; i++) {
            const pl = {
              'payload': {
                'X': dataFiles[i]['X'],
                'Y': dataFiles[i]['Y'],
                'Circuit': report.configuration[typeCard].CurveFit.equivalentCircuit.Circuit
              }
            }
						const headers = {
							'Content-Type': 'application/json',
						};
							headers.Authorization = `Bearer ${store.getters.getTokenMiddlewareAuth}`;
            let response = await axios.post('/bda/v0/fitCircuit', pl,{headers});

            if (response.data.success) {
              dataFiles[i]['Ysim'] = response.data.data.Ysim
              dataFiles[i]['FittedCircuitParameters'] = response.data.data.FittedCircuitParameters
            } else {
              parent.$notifTerm.addNotification(
                parent.$notifTerm.typesNotif.WARNING,
                'Warning',
                'lastError' in response.data ? response.data.lastError : 'Could not process circuit fit',
                'Report Cards Assembly'
              );
            }
            parent.completedSteps++; //Trick to update the Loading effect
          }
        }
       }

		const responseBackEnd = await GeneratePlot.getPlot(parent,
                                                       dataFiles,
                                                       report.configuration[typeCard],
                                                       report[ExtraConfigKey],
                                                       report.configuration[typeCard][ConfigName.BasePropStudy][ConfigName.legendStudy],
                                                       url_req,
                                                       extraPayload); //Request the graphs from the Back-End
		return responseBackEnd
	},
	getStudiesReport(report){
		const studies = Object.keys(report.configuration).filter((val) => val !== FilesConfigKey);
		if (
			report[ExtraConfigKey][NameExtraConfig.ExternPayload] &&
			report.files.some((f) => f.dataType === DATA_TYPE_EXTERN_PAYLOAD)
		) {
			studies.push(EXTERN_STUDY);
		}
		if (studies.length === 0) {
			return;
		}
		return studies;
	},
	getMapping(report) {
		return (
			NameExtraConfig.MappingPresent in report[ExtraConfigKey] &&
			report[ExtraConfigKey][NameExtraConfig.MappingPresent]
		);
	},
	async getStatesList(report) {
		const states = ['default'];
		let removeDefault = true;
    const reportFiles = await getReportFiles(report)
		if (reportFiles.length === 0) {
			return states;
		}
		for (let j = 0; j < reportFiles.length; j++) {
			if (reportFiles[j].dataType !== DATA_TYPE_DATA)
				continue;
			for (let n = 0; n < reportFiles[j].extractedData.length; n++) {
				if ('state' in reportFiles[j].extractedData[n] && reportFiles[j].extractedData[n].state !== '') {
					if (!states.includes(reportFiles[j].extractedData[n].state))
						states.push(reportFiles[j].extractedData[n].state);
				}else
					removeDefault = false;
			}
		}
		if (removeDefault)
			states.splice(0, 1); //Remove the Default if all the extracted data has a state or the report does not have files
		return states;
	},
	applyTemplate(report, template) {
		const keys = Object.keys(template);
		report.graphs = {}; //Reset the graphs so it forces to retrieve from the Back-End
		for (let j = 0; j < keys.length; j++) {
			const key = keys[j];
			if (nonApplicableKeysTemplate.includes(key)) {
				continue;
			}
			report[key] = template[key];
		}
	},
	getLightReport(report) {
		const lightReport = {
			//First the common keys
			name: report.name,
			projectId: report.projectId,
			dateLastUpdate: report.dateLastUpdate,
			operator: report.operator,
			shortId: report.shortId,
			id: report.id,
			sensorBatchId: report.sensorBatchId,
			dateTest: report.dateTest,
			reviewers: report.reviewers
		};
		if ('configWindows' in report) {
			lightReport.configWindows = report.configWindows;
		}
		if ('comparing' in report) {
			lightReport.comparing = report.comparing;
		}
		if ('textReportComparing' in report) {
			lightReport.textReportComparing = report.textReportComparing;
		}
		if ('protocol' in report) {
			lightReport.protocol = report.protocol;
		}
		if ('hypothesis' in report) {
			lightReport.hypothesis = report.hypothesis;
		}
		if ('equipment' in report) {
			lightReport.equipment = report.equipment;
		}
		if ('results' in report) {
			lightReport.results = report.results;
		}
		if ('conclusion' in report) {
			lightReport.conclusion = report.conclusion;
		}
		return lightReport;
	},
	isReportUncomplete(parent, report) {
    if(report.linkReportId)
      return false;
		for (const property of elementsValidate) {
			if (
				typeof report[property.key] === 'undefined' ||
				report[property.key] === ''
			) {
				return true;
			}
		}
		// Validate the title
		if (
			report.name === `New report ${parent.getNameCurrProjectNavigation}`
		) {
			return true;
		}
		return false;
	},
	async verifyReport(parent, report) {
		const missingElements = [];
		for (const property of elementsValidate) {
			if (
				typeof report[property.key] === 'undefined' ||
				report[property.key] === ''
			) {
				missingElements.push(property.text);
			}
		}
		let messageAlert = '';
		if (
			report.name === `New report ${parent.getNameCurrProjectNavigation}`
		) {
			messageAlert = 'The report has the default name';
		}
		if (missingElements.length > 0) {
			const missingFormatted = missingElements.join(', ');
			messageAlert += `${
				messageAlert === '' ? 'M' : ' and m'
			}issing fields: "${missingFormatted}"`;
		}
		if (messageAlert !== '') {
			try {
				await parent.$confirm(
					`${messageAlert}. Do you want to save anyway?`,
					'Incomplete report',
					'warning',
					{
						confirmButtonText: 'Save',
					},
				);
			} catch {
				return false;
			}
		}
		return true;
	},
	async getReportCards(parent, report, forced = false) {

    let readFromDB = !parent.forceUpdateBackEnd; //If it is forced from the user
    if (forced || report.forceUpdateWhenOpen) {
      readFromDB = false;
    }
    if (typeof report.forceUpdateWhenOpen !== 'undefined') {
      delete report.forceUpdateWhenOpen;
    }
    //Validate the data in the report and initialize
    let studies = [];
    const thirdParty =
      typeof report[ExtraConfigKey][NameExtraConfig.ThirdPartyBackEnd] !==
      'undefined';
    if (report.type === Individual_Type && !thirdParty) {
      studies = this.getStudiesReport(report)
      if(typeof(studies)==='undefined'){
        return { cardsReport: {}, orderCards: [] };
      }
      parent.totalSteps = studies.length + 1; //The number of steps are the graphs and the extraction of the dataFiles
      //Validate the graph information from the database
      if (readFromDB) {
        for (let n = 0; n < studies.length; n++) {
          if (
            !('graphs' in report) ||
            (!(studies[n] in report.graphs))
          ) {
            readFromDB = false;
            break;
          }
        }
      }
    } else if (report.type === Comparison_Type || thirdParty) {
      parent.totalSteps = 1; //Steps are the number of reports under comparison and the request to the dtaabase
      if (readFromDB) {
        if (
          typeof report.graphs.success === 'undefined' &&
          typeof report.graphs.correct === 'undefined'
        ) {
          readFromDB = false;
        }
      }
    } else {
      throw `The report type ${report.type} was not recognized`;
    }

    if (!readFromDB && !forced) {
      //If not read from database there is a change in the report
      parent.setReportModifiedReportViewer();
    }


    //Notifying the user
    const originData = readFromDB ? 'Database' : 'Back-End';
    const infoTitle = 'Extracting data';
    const infoText = `Extracting of report '${report.name}' data from the ${originData}`;
    const infoZone = 'Report Cards Assembly';
    parent.$notifTerm.addNotification(
      parent.$notifTerm.typesNotif.INFO,
      infoTitle,
      infoText,
      infoZone,
    );
    //Get the cards of the report
    const cardsReport = {};
    const orderCards = [];
    if (thirdParty && report.type === Individual_Type) {
      let responseBackEnd = {};
      if (readFromDB) {
        await parent.$nextTick(); //It requires wait until next tick, otherwise the plots are not shown correctly
        responseBackEnd = report.graphs;
      } else {
        const thirdPartyRoute =
          report[ExtraConfigKey][NameExtraConfig.ThirdPartyBackEnd];
        let dataThirdParty = null;
        if (report[ExtraConfigKey][NameExtraConfig.DataSourceBackEnd]) {
          dataThirdParty = await GeneratePlot.getDataFromSource(
            parent,
            report[ExtraConfigKey][
              NameExtraConfig.DataSourceBackEnd
            ],
          );
          if (
            dataThirdParty === null ||
            typeof dataThirdParty === 'undefined'
          ) {
            const errorTitle = 'Error Third Party Data Source';
            const errorText =
              'Error while extracting the data from external source';
            const errorZone = 'Report Cards Assembly';
            parent.$notifTerm.addNotification(
              parent.$notifTerm.typesNotif.ERROR,
              errorTitle,
              errorText,
              errorZone,
            );
            return { cardsReport: {}, orderCards: [] };
          }
        } else {
          dataThirdParty = { data: report.files };
        }
        if (!('graphs' in report)) {
          parent.$set(report, 'graphs', {});
        }
        responseBackEnd = await GeneratePlot.getPlotThirdParty(
          parent,
          thirdPartyRoute,
          dataThirdParty,
        );
        report.graphs = responseBackEnd;
      }
      parent.completedSteps++;
      parent.loadingKey += 1; //Trick to update the Loading effect
      if ('warnings' in responseBackEnd) {
        responseBackEnd.warnings.forEach((warning) => {
          const warnTitle = 'Warning during construction';
          const warnText = warning;
          const warnZone = 'Report Cards Assembly';
          parent.$notifTerm.addNotification(
            parent.$notifTerm.typesNotif.WARNING,
            warnTitle,
            warnText,
            warnZone,
          );
        });
      }
      if (responseBackEnd.success || responseBackEnd.correct) {
        Object.assign(cardsReport, responseBackEnd.dataGraph);
        orderCards.push(...Object.keys(responseBackEnd.dataGraph));
      } else {
        const errTitle = 'Cannot create the comparison report';
        const errText = `Failure creating the report with third party. ${responseBackEnd.lastError}`;
        const errZone = 'Report Cards Assembly';
        parent.$notifTerm.addNotification(
          parent.$notifTerm.typesNotif.ERROR,
          errTitle,
          errText,
          errZone,
        );
      }
    } else if (report.type === Individual_Type) {
      parent.completedSteps++;
      parent.loadingKey += 1; //Trick to update the Loading effect
      const keysReportGraphs = Object.keys(report.graphs); //Check if there is no extra dictionaries from other type of studies saved in the graphs.
      for (let k = 0; k < keysReportGraphs.length; k++) {
        const keyReportGraph = keysReportGraphs[k];
        if (!studies.includes(keyReportGraph)) {
          delete report.graphs[keyReportGraph];
        }
      }
      for (let j = 0; j < studies.length; j++) {


        const typeCard = studies[j];
        let responseBackEnd = {};
        if (readFromDB) {
          await parent.$nextTick(); //It requires wait until next tick, otherwise the plots are not shown correctly
          responseBackEnd = report.graphs[studies[j]];
        } else {

          if (typeCard !== EXTERN_STUDY) {


            const responseBackEndTemp = await this.getPlotsFromBackEnd(parent, report, typeCard)
            if (typeof (responseBackEndTemp) === 'undefined')
              continue;
            responseBackEnd = responseBackEndTemp;
          }

            else {
            const payload = report.files.find(
              (f) =>
                f.dataType ===
                DATA_TYPE_EXTERN_PAYLOAD,
            ).extractedData;


            responseBackEnd = await GeneratePlot.getPlotFromPayload(
              parent,
              payload,
            );
          }
          //Save in the report object
          if (!('graphs' in report)) {
            parent.$set(report, 'graphs', {});
          }
          parent.$set(report.graphs, studies[j], responseBackEnd);
        }
        if ('warnings' in responseBackEnd) {
          responseBackEnd.warnings.forEach((warning) => {
            const warnTitle = `Warning during construction ${typeCard}`;
            const warnText = warning;
            const warnZone = 'Report Cards Assembly';
            parent.$notifTerm.addNotification(
              parent.$notifTerm.typesNotif.WARNING,
              warnTitle,
              warnText,
              warnZone,
            );
          });
        }
        if (!responseBackEnd.success && !responseBackEnd.correct) {
          //It is here to print the warning even the construction fails
          const errTitle = 'Error in card';
          const errText = `Cannot create the graphs of '${typeCard}'. The configuration is not allowed. ${responseBackEnd.lastError}`;
          const errZone = 'Report Cards Assembly';
          parent.$notifTerm.addNotification(
            parent.$notifTerm.typesNotif.ERROR,
            errTitle,
            errText,
            errZone,
          );
          continue;
        }

        if (typeof defaultOrderGraphs[typeCard] !== 'undefined') {
          // If the order is defined utilises the values as priorities
          for (
            let n = 0;
            n < defaultOrderGraphs[typeCard].length;
            n++
          ) {
            if (
              typeof responseBackEnd.dataGraph[
                defaultOrderGraphs[typeCard][n]
              ] !== 'undefined'
            ) {
              orderCards.push(defaultOrderGraphs[typeCard][n]);
            }
          }
          // Then just push the elements not prioritised
          const missingElements = Object.keys(
            responseBackEnd.dataGraph,
          ).filter((x) => !orderCards.includes(x));
          orderCards.push(...missingElements);
        } else {
          orderCards.push(...Object.keys(responseBackEnd.dataGraph));
        }

        Object.assign(cardsReport, responseBackEnd.dataGraph);
        parent.completedSteps++;
        parent.loadingKey += 1; //Trick to update the Loading effect
      }
    } else if (report.type === Comparison_Type) {
      let responseBackEnd = {};
      if (readFromDB) {
        await parent.$nextTick(); //It requires wait until next tick, otherwise the plots are not shown correctly
        responseBackEnd = report.graphs;
      } else {
        parent.totalSteps += report.comparing.length;
        const reportsComparing = []; //Stores the reports that will be under comparison
        const keysReports = []; //Stores the studies that the report has in memory
        const sensorBatchIDArr = [];
        parent.setMessageVisibleReportViewer(true); //Set the message visible
        for (let n = 0; n < report.comparing.length; n++) {
          const idReport = report.comparing[n].id; //Extract the ID
          report.comparing[n].shown = false; //Initialize as false the animation that it is shown
          const reportComparing = await store.dispatch('retrieveReportObjtReportViewer', {
            reportId: idReport,
            projectId: report.projectId,
            clusterId: parent.$route.params.clusterId,
            nameStr: `comparing report ${n+1}`
          })
          parent.completedSteps++;
          parent.loadingKey += 1; //Trick to update the Loading effect
          if (reportComparing === null || typeof reportComparing === 'undefined') {
            //If because of something it fails it's not loaded to the array
            continue;
          }
          if (typeof reportComparing.graphs === 'undefined' || Object.keys(reportComparing.graphs).length === 0) {
            const errTitle = 'Report Empty';
            const errText = `The report '${reportComparing.name}' under comparison is empty, it was discarded.`;
            const errZone = 'Report Cards Assembly';
            parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone);
            continue;
          }
          reportsComparing.push(reportComparing);
          const keysGraphs = Object.keys(reportComparing.graphs);
          keysReports.push(keysGraphs);
          report.comparing[n].studies = keysGraphs.length > 0 ? keysGraphs.join(', ') : '---'; //Saves the studies available in the report
          report.comparing[n].shortId = parseInt(reNumber.exec(reportComparing.shortId.toString())[0]);
          if (!sensorBatchIDArr.includes(reportComparing.sensorBatchId)) {
            sensorBatchIDArr.push(reportComparing.sensorBatchId);
          }
        }
        const textReportComparingAuxArr = [];
        report.comparing.forEach((repComp) => {
          textReportComparingAuxArr.push(`${repComp.shortId}(${repComp.studies})`);
        });
        report.textReportComparing = textReportComparingAuxArr.join(', ');
        parent.setMessageVisibleReportViewer(false);
        const intersect = keysReports.reduce((a, b) => a.filter((c) => b.includes(c))); //Check the intersection between the studies that the report has
        if (intersect.length === 0) {
          const errTitle = 'Comparison not valid';
          const errText = `The ${keysReports.length} reports under comparison does not have a common type of study.`;
          const errZone = 'Report Cards Assembly';
          parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone);
          return { cardsReport, orderCards };
        }
        // if (intersect.length > 1) {
        //   //If there is one that more matched studies it will select the first value
        //   const warnTitle = 'Reports discarted';
        //   const warnText = `The ${keysReports.length} reports under comparison has more than one study that coincide, the system will use the last value.`;
        //   const warnZone = 'Report Cards Assembly';
        //   parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone);
        // }

        report.sensorBatchId = sensorBatchIDArr.join(', ');
        const dataComparing = [];
				for (let selectedIntersect = 0; selectedIntersect < intersect.length; selectedIntersect++){
        for (let n = 0; n < reportsComparing.length; n++) {
          if ('comparisonInfo' in reportsComparing[n].graphs[intersect[selectedIntersect]]) {
            //Check that it has the comparison info
            const comparisonInfo = JSON.parse(JSON.stringify(reportsComparing[n].graphs[intersect[selectedIntersect]].comparisonInfo));
            for (const fit in comparisonInfo) {
              if (typeof comparisonInfo[fit]['PARAMETERS'] === 'undefined') {
                //Checks that the required information is in the report
                const warnTitle = 'Invalid reports';
                const warnText = `The report Fit '${reportsComparing[n].name}.${fit}' does not have an Statistical Evaluation. Element excluded.`;
                const warnZone = 'Report Cards Assembly';
                parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone);
                continue;
              }
              let countIdentifier = 'ND';
              if (this.getReportsProjMiddleware !== null) {
                const matchedReport =
                  store.getters.getReportsProjMiddleware.reports.find(
                    (report) =>
                      report.id ===
                      reportsComparing[n].id,
                  );
                if (typeof matchedReport !== 'undefined' &&
                    typeof matchedReport.internalCounter !== 'undefined'
                ) {
                  countIdentifier =
                    matchedReport.internalCounter;
                }
              }
              comparisonInfo[fit].title = `${countIdentifier}. ${reportsComparing[n].name}`;
              dataComparing.push(comparisonInfo[fit]);
            }
          } else {
            const warnTitle = 'Invalid reports';
            const warnText = `The report '${reportsComparing[n].name}' does not have the information required for the analysis, please verify that the report contains a Fit and Statistical Evaluation.`;
            const warnZone = 'Report Cards Assembly';
            parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone);
          }
        }
			}
        // if (dataComparing.length <= 1) {
        //   const errTitle = 'Comparison not valid';
        //   const errText = `The study ${intersect[selectedIntersect]} in the reports under comparison does not have the required information.`;
        //   const errZone = 'Report Cards Assembly';
        //   parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone);
        //   return { cardsReport, orderCards };
        // }
        responseBackEnd = await GeneratePlot.getComparison(parent, dataComparing); //Request the graphs from the Back-End
        if (!('graphs' in report)) {
          parent.$set(report, 'graphs', {});
        }
        report.graphs = responseBackEnd;
      }
      parent.completedSteps++;
      parent.loadingKey += 1; //Trick to update the Loading effect
      if ('warnings' in responseBackEnd) {
        responseBackEnd.warnings.forEach((warning) => {
          const warnTitle = 'Warning during construction';
          const warnText = warning;
          const warnZone = 'Report Cards Assembly';
          parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone);
        });
      }
      if (responseBackEnd.success || responseBackEnd.correct) {
        Object.assign(cardsReport, responseBackEnd.dataGraph);
        orderCards.push(...Object.keys(responseBackEnd.dataGraph));
      } else {
        const errTitle = 'Cannot create the comparison report';
        const errText = `Failure creating the comparison report. ${responseBackEnd.lastError}`;
        const errZone = 'Report Cards Assembly';
        parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone);
      }
    }
    return { cardsReport, orderCards };
  },
};

export default ReportInfo;
